module.exports = __webpack_public_path__ + "static/img/failure.2d340f5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activity-boost/failure.svg
// module id = oF8q
// module chunks = 1